import React, { Fragment, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// Components
import ThemeMenuThree from '../../../components/header/ThemeMenuThree';
import PageTitle from '../../../components/page-title/PageTitle';
import NewsletterTwo from '../../../components/call-to-action/NewsletterTwo';
import FooterThree from '../../../components/footer/FooterThree';

const ProductDetails = () => {
  const location = useLocation();
  const [productIcons, setProductIcons] = useState([]);
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [operator, setOperator] = useState('');

  const productId = location.state?.productId;
  console.log('Received productId:', productId);

  useEffect(() => {
    const fetchIconsAndProducts = async () => {
      try {
        // Fetch icons data
        const iconResponse = await fetch('https://sumbupulsa.com/harga/getIcons.php');
        const iconData = await iconResponse.json();
        console.log('Icon data fetched:', iconData);
        setProductIcons(iconData);

        // Find selected icon by productId (convert to number for comparison)
        const selectedIcon = iconData.find((icon) => parseInt(icon.id) === parseInt(productId));
        if (selectedIcon) {
          // Set operator from the selected icon
          setOperator(selectedIcon.operator);
          console.log('Selected icon operator:', selectedIcon.operator);

          // Fetch product data only after icon is found
          const productResponse = await fetch('https://sumbupulsa.com/harga/getProduk.php');
          const productData = await productResponse.json();
          console.log('Produk data fetched:', productData);
          setProducts(productData);

          // Filter products based on the operator from selectedIcon
          const filtered = productData.filter((product) =>
            product.operator === selectedIcon.operator
          );
          setFilteredProducts(filtered);
        } else {
          console.log('Icon tidak ditemukan untuk productId:', productId); // Jika icon tidak ditemukan
        }
        
        setLoading(false);
      } catch (error) {
        console.error('Terjadi kesalahan saat mengambil data:', error);
        setLoading(false);
      }
    };

    if (productId) {
      fetchIconsAndProducts();
    }
  }, [productId]);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <Fragment>
      <div className="main-page-wrapper">
        {/* Helmet start */}
        <Helmet>
          <title>Daftar Harga</title>
        </Helmet>
        {/* Helmet end */}

        {/* ThemeMenuThree */}
        <ThemeMenuThree />
        {/* ThemeMenuThree */}

        {/* PageTitle */}
        <PageTitle title="Cek Harga" />
        {/* PageTitle */}

        {/* FAQ start */}
        <div className="product-details">
          <h1 className="title">Detail Produk</h1>

          {/* Menampilkan tabel produk yang terfilter berdasarkan operator */}
          {filteredProducts.length > 0 ? (
            <div className="operator-section">
              <h4 className="operator-name">Operator: {operator}</h4>
              <table className="product-table">
                <thead>
                  <tr>
                    <th>Operator</th>
                    <th>Kode</th>
                    <th>Harga Jual</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredProducts.map((product) => (
                    <tr key={product.id}>
                      <td>{product.operator}</td>
                      <td>{product.kode}</td>
                      <td>{`Rp ${Number(product.harga_jual).toLocaleString('id-ID')}`}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p>Tidak ada produk untuk operator ini.</p>
          )}

          <style>
            {`
              /* Dark background with contrasting text for a programmer feel */
              .product-details {
                background-color: #121e2b;
                color: #d1d1d1;
                padding: 20px;
                border-radius: 8px;
                max-width: 900px;
                margin: 0 auto;
              }

              .title {
                color: #4fa3f7;
                text-align: center;
                font-size: 2.5rem;
                margin-bottom: 20px;
              }

              .operator-name {
                color: #4fa3f7;
                margin-bottom: 10px;
                font-size: 1.5rem;
              }

              .product-table {
                width: 100%;
                border-collapse: collapse;
                margin-top: 10px;
                background-color: #1a232f;
                border-radius: 8px;
              }

              .product-table th,
              .product-table td {
                padding: 12px;
                text-align: center;
                border: 1px solid #4fa3f7;
              }

              .product-table th {
                background-color: #2a3b4f;
                color: #ffffff;
              }

              .product-table tr:nth-child(even) {
                background-color: #273344;
              }

              .product-table tr:hover {
                background-color: #365877;
                cursor: pointer;
              }

              .loading {
                color: #4fa3f7;
                font-size: 1.5rem;
                text-align: center;
                margin-top: 50px;
              }
            `}
          </style>
        </div>
        {/* FAQ end */}

        {/* FooterThree start */}
        <FooterThree />
        {/* FooterThree end */}
      </div>
    </Fragment>
  );
};

export default ProductDetails;
